export const DataHooks = {
    /** popover arrow */
    arrow: 'popover-arrow',
    /** popover anchor */
    element: 'popover-element',
    /** popover portal */
    portal: 'popover-portal',
    /** popover content */
    content: 'popover-content',
};
//# sourceMappingURL=const.js.map